import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config'; // Ensure this points to your config file with API settings

const Settings = () => {
  // Set up form data state with initial empty values
  const [formData, setFormData] = useState({
    app_name: '',
    app_description: '',
    logo: '',
    favicon: '',
  });

  // Fetch existing settings data when the component mounts
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/settings`);
        const data = response.data;

        // Pre-fill form fields with fetched data if available
        setFormData({
          app_name: data.app_name || '',
          app_description: data.app_description || '',
          logo: data.logo || '',
          favicon: data.favicon || '',
        });
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchSettings();
  }, []);

  // Handle text input changes
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle file input changes for logo and favicon
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files?.[0];
    if (file) {
      setFormData({ ...formData, [name]: file }); // Store the file object in state
    }
  };

  // Handle form submission to update settings
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append('app_name', formData.app_name);
    formData.append('app_description', formData.app_description);
  
    if (formData.logo instanceof File) {
      formData.append('logo', formData.logo);
    }
    if (formData.favicon instanceof File) {
      formData.append('favicon', formData.favicon);
    }
  
    try {
      const response = await axios.post(`${config.apiBaseUrl}/settings`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Settings updated successfully');
    } catch (error) {
      console.error('Error updating settings:', error);
      alert('Failed to update settings');
    }
  };
  

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">System Settings</h4>
              <p className="card-description">Configure your application settings</p>
              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="app_name">Application Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="app_name"
                    name="app_name"
                    value={formData.app_name}
                    onChange={handleInputChange}
                    placeholder="Enter application name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="app_description">Application Description</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="app_description"
                    name="app_description"
                    value={formData.app_description}
                    onChange={handleInputChange}
                    placeholder="Enter application description"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="logo">Logo</label>
                  <input
                    type="file"
                    className="form-control"
                    id="logo"
                    name="logo"
                    onChange={handleFileChange}
                  />
                  {/* Display the current logo if it exists and is a URL */}
                  {typeof formData.logo === 'string' && formData.logo && (
                    <img
                      src={`${config.fileBaseUrl}${formData.logo}`} // Combine with fileBaseUrl if necessary
                      alt="Current logo"
                      style={{ width: '100px', marginTop: '10px' }}
                    />
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="favicon">Favicon</label>
                  <input
                    type="file"
                    className="form-control"
                    id="favicon"
                    name="favicon"
                    onChange={handleFileChange}
                  />
                  {/* Display the current favicon if it exists and is a URL */}
                  {typeof formData.favicon === 'string' && formData.favicon && (
                    <img
                      src={`${config.fileBaseUrl}${formData.favicon}`} // Combine with fileBaseUrl if necessary
                      alt="Current favicon"
                      style={{ width: '32px', marginTop: '10px' }}
                    />
                  )}
                </div>
                <button type="submit" className="btn btn-primary mr-2">Save</button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setFormData({
                    app_name: '',
                    app_description: '',
                    logo: '',
                    favicon: '',
                  })}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
